import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import home from '@/view/home'
import list from '@/view/list'
import groupLeader from '@/view/groupLeader' // 组长简介
import research from '@/view/research'
import member from '@/view/member'
import facilities from '@/view/facilities'
// import collaboration from '@/view/collaboration'
import publications from '@/view/publications'
import patents from '@/view/patents'
// import literature from '@/view/literature'

import groupAlbum from '@/view/groupAlbum'
import joinUs from '@/view/joinUs'
import detail from '@/view/detail'
import memberDetail from '@/view/memberDetail'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: home,
      cn: '首页'
    },
    {
      path: '/groupLeader',
      name: 'Group Leader',
      component: groupLeader,
      cn: '团队负责人'
    },
    {
      path: '/research',
      name: 'Research',
      component: research,
      cn: '研究方向'
    },
    {
      path: '/member',
      name: 'Member',
      component: member,
      cn: '研究团队'
    },
    {
      path: '/facilities',
      name: 'Facilities',
      component: facilities,
      cn: '实验设备'
    },
    // {
    //   path: '/collaboration',
    //   name: 'Collaboration',
    //   component: collaboration,
    //   cn: '合作研究'
    // },
    {
      path: '/publications',
      name: 'Publications',
      component: publications,
      cn: '发表论文'
    },
    {
      path: '/patents',
      name: 'Patents',
      component: patents,
      cn: '发表专利'
    },
    // {
    //   path: '/literature',
    //   name: 'Literature',
    //   component: literature,
    //   cn: '文献阅读'
    // },
    {
      path: '/groupAlbum',
      name: 'Group Album',
      component: groupAlbum,
      cn: '团队生活'
    },
    {
      path: '/joinUs',
      name: 'Join Us',
      component: joinUs,
      cn: '加入我们'
    },
    {
      path: '/list',
      name: 'News',
      component: list,
      cn: '通用列表',
      hidden: true
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail,
      cn: '富文本展示页面',
      hidden: true
    },
    {
      path: '/memberDetail',
      name: 'memberDetail',
      component: memberDetail,
      cn: '团队成员详情页',
      hidden: true
    }
  ]
})
